<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Details from "@/router/views/dts/dts-modal/details";
import Logs from "@/router/views/dts/dts-modal/logs";
import PrintOptions from "@/components/modals/print-options.vue";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Office Tracks"
  },
  components: {
    Layout,
    PageHeader,
    Details,
    Logs,
    PrintOptions,
    RawData
  },
  data() {
    return {
      title: "Process Tracks",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Process Tracks",
          active: true
        }
      ],
      tableData: [],
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      loadComplete: false,
      filter: "",
      loading: false,
      searchString: "",
      firstSearch: false
    };
  },
  methods: {
    getTracks(previousId) {
      if (this.searchString.trim() == "") {
        return;
      }
      if (previousId == 0) this.tableData = [];
      this.loading = true;
      this.loadComplete = false;
      this.$store
        .dispatch("dtstrack/GetTrackBySearch", {
          searchString: this.searchString,
          previousId: previousId,
          take: this.perPage
        })
        .then((res) => {
          if (res.data.length < this.perPage) {
            this.loadComplete = true;
            this.showToast("Retrieved all related tracks!", "success");
          }
          this.tableData = this.tableData.concat(res.data);
          this.firstSearch = true;
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast("Something went wrong - Getting tracks!", "error");
          }
          this.loading = false;
        });
    },
    viewDetails(id) {
      this.$refs.details.getData(id);
    },
    viewLogs(id) {
      this.$refs.logs.getData(id);
    },
    printSingleTrackingReport(id) {
      var apiUrl = `dts/api/Report/Tracking`;
      var routeVariables = [];
      var body = [];
      body.push({ id: id });
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    }
  }
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      v-if="!firstSearch"
      class="h-50vh d-flex align-items-center justify-content-center"
    >
      <div>
        <h2 class="d-flex align-items-center justify-content-center mb-5">
          Search Process Tracks
        </h2>
        <div class="card" style="width: 900px !important">
          <b-input-group>
            <input
              autocomplete="off"
              type="text"
              placeholder="Search Tracks..."
              class="form-control form-control-lg"
              v-model="searchString"
              v-on:keyup.enter="getTracks(0)"
            />
          </b-input-group>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="min-width: 950px">
        <div class="d-flex align-items-center justify-content-between">
          <h5 class="mb-0">List of Tracks</h5>
          <div class="card" style="width: 400px">
            <b-input-group>
              <input
                autocomplete="off"
                type="text"
                placeholder="Search Tracks..."
                class="form-control"
                v-model="searchString"
                v-on:keyup.enter="getTracks(0)"
              />
            </b-input-group>
          </div>
        </div>
        <b-card v-if="loading">
          <div class="d-flex align-items-center justify-content-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-25px h-25px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <h5 class="mb-0">Loading...</h5>
          </div>
        </b-card>
        <b-card class="text-center" v-else-if="tableData.length == 0">
          <div v-if="filter != ''">
            <i class="fas fa-exclamation-triangle me-2"></i>There are no tracks
            matching your request
          </div>
          <div v-else>
            <i class="fas fa-exclamation-triangle me-2"></i>No tracks available
          </div>
        </b-card>
        <div v-else class="text-muted">
          <b-card no-body class="m-0 mb-3">
            <b-card-header>
              <div class="row align-items-center">
                <div class="col-8">
                  <b>Process Track</b>
                </div>
                <div class="col-2">
                  <b>Action Request</b>
                </div>
                <div class="col-2">
                  <b>Status</b>
                </div>
              </div>
            </b-card-header>
          </b-card>
          <div role="tablist" v-for="(x, index) in tableData" :key="x.id">
            <div class="position-relative ms-1">
              <RawData
                :data="x"
                v-if="$store.state.decrypt.isAdmin()"
                :style="`z-index: ${tableData.length - index + 11}`"
              />
            </div>
            <b-card
              no-body
              class="m-0 mb-3 py-1"
              :style="`z-index: ${tableData.length - index + 10}`"
            >
              <b-card-header>
                <div class="row">
                  <div class="col-8">
                    <div>{{ x.referenceNumber }}</div>
                    <b class="text-white">{{ x.title }}</b>
                    <div class="d-flex align-items-center">
                      <div>
                        <small>
                          <a
                            href="javascript: void(0);"
                            class="text-info"
                            @click="viewDetails(x.id)"
                          >
                            View Details
                          </a>
                        </small>
                      </div>
                      <span class="mx-2">|</span>
                      <div>
                        <small>
                          <a
                            href="javascript: void(0);"
                            class="text-warning"
                            @click="viewLogs(x.id)"
                          >
                            View Logs
                          </a>
                        </small>
                      </div>
                    </div>
                  </div>
                  <div class="col-2">
                    {{ x.actionNeeded }}
                  </div>
                  <div class="col-2">
                    <div v-if="x.status == 'DRAFT'">
                      <span class="text-info">CREATED</span> on
                      {{ formatDateWithTime(new Date(x.dateTimeCreated)) }}
                    </div>
                    <div v-if="x.status == 'PENDING'">
                      <div>
                        <span class="text-info">SENT</span> on
                        {{ formatDate(new Date(x.dateTimePosted)) }}
                      </div>
                    </div>
                    <div v-if="x.status == 'RETURNED'">
                      <span class="text-warning">{{ x.status }}</span>
                      on
                      {{ formatDate(new Date(x.dateTimePosted)) }}
                    </div>
                    <div v-if="x.status == 'RECEIVED'">
                      <span class="text-pink">{{ x.status }}</span>
                      on
                      {{ formatDate(new Date(x.dateTimeReceived)) }}
                    </div>
                    <div v-if="x.status == 'COMPLETED'">
                      <span class="text-success">PROCESSED</span> on
                      {{ formatDateWithTime(new Date(x.actionDateTime)) }}
                    </div>
                  </div>
                </div>
              </b-card-header>
            </b-card>
          </div>
          <div class="text-center my-5">
            <button
              v-if="!loadComplete"
              type="button"
              @click="getTracks(tableData[tableData.length - 1].id)"
              class="btn btn-primary"
            >
              Load More...
            </button>
          </div>
        </div>
      </div>
    </div>
    <Details
      user="all"
      @printTrackingReport="printSingleTrackingReport($event)"
      ref="details"
    ></Details>
    <Logs @viewDetails="viewDetails($event)" ref="logs"></Logs>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.multiselect__option--group {
  padding-top: 16px;
  padding-bottom: 0;
  background: #2a3042 !important;
  color: #bfc8e2 !important;
  font-weight: bold !important;
  font-size: medium !important;
}
</style>
